import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';

interface SubscriptionUpgradeModalProps {
  visible: boolean;
  onHide: () => void;
  isExpired?: boolean;
}

const SubscriptionUpgradeModal: React.FC<SubscriptionUpgradeModalProps> = ({ visible, onHide, isExpired = false }) => {
  const history = useHistory();

  const handleUpgradeClick = () => {
    history.push('/subscription');
    onHide();
  };

  const handleAffiliateClick = () => {
    history.push('/referral-stats');
    onHide();
  };

  const header = isExpired ? "Abonnement expiré" : "Limite de chauffeurs atteinte";
  const mainMessage = isExpired 
    ? "Votre abonnement a expiré. Pour continuer à utiliser le service, vous avez deux options :"
    : "Vous avez atteint la limite de chauffeurs pour votre compte actuel. Pour ajouter plus de chauffeurs, vous avez deux options :";

  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={header}
      modal
      className="font-sans text-md rounded-xl overflow-hidden shadow-lg bg-white p-6 w-full max-w-2xl mx-auto"
      contentClassName="p-4"
    >
      <div className="flex flex-col gap-6">
        <p className="text-gray-700">
          {mainMessage}
        </p>
        
        <div className="flex flex-col gap-4">
          <div className="p-4 border rounded-lg bg-gray-50">
            <h3 className="text-lg font-semibold mb-2 mt-0">Option 1: Passer au plan Premium</h3>
            <p className="text-gray-600 mb-4">
              Passez au plan premium pour obtenir un nombre illimité de chauffeurs et accéder à toutes les fonctionnalités avancées.
            </p>
            <Button
              label="Passer au Premium"
              icon="pi pi-star"
              className="bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white px-4 py-2 rounded-lg transition-all duration-300 border-none outline-none font-sans font-medium"
              onClick={handleUpgradeClick}
            />
          </div>

          <div className="p-4 border rounded-lg bg-gray-50">
            <h3 className="text-lg font-semibold mb-2 mt-0">Option 2: Programme de parrainage</h3>
            <p className="text-gray-600 mb-4">
              Parrainez d'autres transporteurs et obtenez des avantages :
              <ul className="list-disc ml-6 mt-2">
                <li>1er parrainage : +1 chauffeur supplémentaire</li>
                <li>5 parrainages : 2 mois d'accès illimité aux chauffeurs</li>
              </ul>
            </p>
            <Button
              label="Voir mon programme de parrainage"
              icon="pi pi-users"
              className="bg-gradient-to-r from-slate-400 to-slate-500 hover:from-slate-500 hover:to-slate-600 text-white px-4 py-2 rounded-lg transition-all duration-300 border-none outline-none font-sans font-medium"
              onClick={handleAffiliateClick}
            />
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default SubscriptionUpgradeModal;
